import { render, staticRenderFns } from "./pwa_news_list.vue?vue&type=template&id=347aad0d&scoped=true&"
import script from "./pwa_news_list.vue?vue&type=script&lang=js&"
export * from "./pwa_news_list.vue?vue&type=script&lang=js&"
import style0 from "./pwa_news_list.vue?vue&type=style&index=0&id=347aad0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347aad0d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('347aad0d')) {
      api.createRecord('347aad0d', component.options)
    } else {
      api.reload('347aad0d', component.options)
    }
    module.hot.accept("./pwa_news_list.vue?vue&type=template&id=347aad0d&scoped=true&", function () {
      api.rerender('347aad0d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/news/list/pwa_news_list.vue"
export default component.exports